"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
class DateRange {
}
exports.DateRange = DateRange;
//# sourceMappingURL=date-range.js.map